import { isly } from "isly";
import { Year } from "../Year";
import { Numeric as MonthNumeric } from "./Numeric";
export var Month;
(function (Month) {
    var _a;
    Month.Numeric = MonthNumeric;
    Month.values = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    _a = isly
        .string("value", ...Month.values)
        .rename("isoly.Date.Month")
        .bind(), Month.type = _a.type, Month.is = _a.is, Month.flawed = _a.flawed;
    function create(value) {
        return Month.type.get(value.toString().padStart(2, "0"));
    }
    Month.create = create;
    function length(month, year) {
        return {
            "01": 31,
            "02": year != undefined && Year.isLeapYear(year) ? 29 : 28,
            "03": 31,
            "04": 30,
            "05": 31,
            "06": 30,
            "07": 31,
            "08": 31,
            "09": 30,
            "10": 31,
            "11": 30,
            "12": 31,
        }[month];
    }
    Month.length = length;
})(Month || (Month = {}));
//# sourceMappingURL=index.js.map